<ul class="widget-list" *ngIf="categoriesArr && categoriesArr.length">
    <li *ngFor="let item of categoriesArr">
        <a href="#">{{item}}</a>
    </li>
</ul>